var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { BLACK, BLACK_600, BLUE_500, WHITE } from '../../constants/colors';
import { useBreakpoint } from '../../hooks';
import { InfoIcon } from '../../icons';
import { StateConfigContext } from '../../providers';
import { checkIsPlatform, getTestId } from '../../utils';
import { Avatar } from '../avatar';
import { Button } from '../button';
import { Checkbox } from '../checkbox';
import { Divider } from '../divider';
import { DynamicSvg } from '../dynamic-svg';
import { GradientView } from '../gradient-view';
import { InfoTag } from '../info-tag';
import { Loader } from '../loader';
import { Lottie } from '../lottie/Lottie';
import { Radio } from '../radio';
import { Switch } from '../switch';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { getActionTypeTextStateColor, getLinkListItemComponentSize, getLinkListItemProps, getLinkListItemStyles, getSubHeadingBoldTypeColor, getTypography, getTypographyColorWithDifferentStates } from './LinkListItemStyles';
export var LinkListItem = forwardRef((props, ref) => {
  var _a, _b;
  var stateContext = useContext(StateConfigContext);
  var _controlState = props.controlState,
    disabled = props.disabled;
  var _useState = useState(disabled || _controlState === 'disabled'),
    isDisabled = _useState[0],
    setIsDisabled = _useState[1];
  var linkListItemProps = getLinkListItemProps(Object.assign(Object.assign({}, props), {
    disabled: isDisabled
  }), stateContext);
  var controlState = linkListItemProps.controlState;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var stylesBasedOnState = useRef(getLinkListItemStyles(linkListItemProps, 'none', isLargeScreen));
  var theme = linkListItemProps.theme,
    title = linkListItemProps.title,
    heading = linkListItemProps.heading,
    headingTextTransform = linkListItemProps.headingTextTransform,
    subHeading = linkListItemProps.subHeading,
    subHeadingTextTransform = linkListItemProps.subHeadingTextTransform,
    subHeadingNumberOfLines = linkListItemProps.subHeadingNumberOfLines,
    subHeadingBold = linkListItemProps.subHeadingBold,
    subHeadingBoldColor = linkListItemProps.subHeadingBoldColor,
    _linkListItemProps$su = linkListItemProps.subHeadingBoldControlState,
    subHeadingBoldControlState = _linkListItemProps$su === void 0 ? 'none' : _linkListItemProps$su,
    showSubHeadingInfoIcon = linkListItemProps.showSubHeadingInfoIcon,
    subHeadingTooltipProps = linkListItemProps.subHeadingTooltipProps,
    subHeadingInfoIconPress = linkListItemProps.subHeadingInfoIconPress,
    multiTextSubText = linkListItemProps.multiTextSubText,
    subText = linkListItemProps.subText,
    subTextBold = linkListItemProps.subTextBold,
    multiTextHeading = linkListItemProps.multiTextHeading,
    multiTextSubHeading = linkListItemProps.multiTextSubHeading,
    _linkListItemProps$su2 = linkListItemProps.subTextBoldControlState,
    subTextBoldControlState = _linkListItemProps$su2 === void 0 ? 'none' : _linkListItemProps$su2,
    showsSubTextInfoIcon = linkListItemProps.showsSubTextInfoIcon,
    subTextTooltipProps = linkListItemProps.subTextTooltipProps,
    subTextInfoIconPress = linkListItemProps.subTextInfoIconPress,
    metaInfoTag = linkListItemProps.metaInfoTag,
    metaInfoTagIcon = linkListItemProps.metaInfoTagIcon,
    metaInfoTagType = linkListItemProps.metaInfoTagType,
    metaInfoText = linkListItemProps.metaInfoText,
    metaInfoCta = linkListItemProps.metaInfoCta,
    metaInfoCtaAccessibilityProps = linkListItemProps.metaInfoCtaAccessibilityProps,
    metaInfoCtaProps = linkListItemProps.metaInfoCtaProps,
    avatarIcon = linkListItemProps.avatarIcon,
    avatarImgUrl = linkListItemProps.avatarImgUrl,
    avatarOnErrorImgUrl = linkListItemProps.avatarOnErrorImgUrl,
    avatarNoBgContainer = linkListItemProps.avatarNoBgContainer,
    avatarAsOffer = linkListItemProps.avatarAsOffer,
    _avatarProps = linkListItemProps.avatarProps,
    _linkListItemProps$sh = linkListItemProps.showAvatarTooltip,
    showAvatarTooltip = _linkListItemProps$sh === void 0 ? false : _linkListItemProps$sh,
    avatarTooltipProps = linkListItemProps.avatarTooltipProps,
    actionType = linkListItemProps.actionType,
    _onPress = linkListItemProps.onPress,
    style = linkListItemProps.style,
    showDivider = linkListItemProps.showDivider,
    showInfoIcon = linkListItemProps.showInfoIcon,
    infoIconAccessibilityProps = linkListItemProps.infoIconAccessibilityProps,
    _linkListItemProps$sh2 = linkListItemProps.showOnMountInfoIconTooltip,
    showOnMountInfoIconTooltip = _linkListItemProps$sh2 === void 0 ? false : _linkListItemProps$sh2,
    infoIconTooltipProps = linkListItemProps.infoIconTooltipProps,
    headingInfoTag = linkListItemProps.headingInfoTag,
    metaInfoCtaPress = linkListItemProps.metaInfoCtaPress,
    headingIconName = linkListItemProps.headingIconName,
    subHeadingIconName = linkListItemProps.subHeadingIconName,
    subHeadingIconProps = linkListItemProps.subHeadingIconProps,
    subHeadingPrefixIconName = linkListItemProps.subHeadingPrefixIconName,
    subHeadingPrefixIconProps = linkListItemProps.subHeadingPrefixIconProps,
    subTextPrefixIconName = linkListItemProps.subTextPrefixIconName,
    subTextPrefixIconProps = linkListItemProps.subTextPrefixIconProps,
    subText2PrefixIconName = linkListItemProps.subText2PrefixIconName,
    subText2PrefixIconProps = linkListItemProps.subText2PrefixIconProps,
    subTextIconName = linkListItemProps.subTextIconName,
    subTextIconProps = linkListItemProps.subTextIconProps,
    infoIconPress = linkListItemProps.infoIconPress,
    refreshCtaData = linkListItemProps.refreshCtaData,
    onRefreshCtaTimerComplete = linkListItemProps.onRefreshCtaTimerComplete,
    onRefreshCtaPress = linkListItemProps.onRefreshCtaPress,
    _linkListItemProps$he = linkListItemProps.headingIconColor,
    headingIconColor = _linkListItemProps$he === void 0 ? BLACK : _linkListItemProps$he,
    _linkListItemProps$he2 = linkListItemProps.headingInfoTagType,
    headingInfoTagType = _linkListItemProps$he2 === void 0 ? 'new' : _linkListItemProps$he2,
    actionTypeOnPress = linkListItemProps.actionTypeOnPress,
    actionTypeProps = linkListItemProps.actionTypeProps,
    selected = linkListItemProps.selected,
    _linkListItemProps$te = linkListItemProps.testID,
    testID = _linkListItemProps$te === void 0 ? 'LinkListItem' : _linkListItemProps$te,
    _linkListItemProps$ac = linkListItemProps.accessible,
    accessible = _linkListItemProps$ac === void 0 ? false : _linkListItemProps$ac,
    titleAccessibilityProps = linkListItemProps.titleAccessibilityProps,
    headingAccessibilityProps = linkListItemProps.headingAccessibilityProps,
    subHeadingAccessibilityProps = linkListItemProps.subHeadingAccessibilityProps,
    subTextAccessibilityProps = linkListItemProps.subTextAccessibilityProps,
    metaInfoTextAccessibilityProps = linkListItemProps.metaInfoTextAccessibilityProps,
    showCtaLoader = linkListItemProps.showCtaLoader,
    _linkListItemProps$dy = linkListItemProps.dynamicTooltipProps,
    dynamicTooltipProps = _linkListItemProps$dy === void 0 ? {} : _linkListItemProps$dy,
    showDynamicTooltip = linkListItemProps.showDynamicTooltip,
    _linkListItemProps$sh3 = linkListItemProps.showHeadingLottie,
    showHeadingLottie = _linkListItemProps$sh3 === void 0 ? false : _linkListItemProps$sh3,
    headingLottieProps = linkListItemProps.headingLottieProps,
    config = linkListItemProps.config,
    isLoading = linkListItemProps.isLoading,
    subText3InfoIconPress = linkListItemProps.subText3InfoIconPress,
    subText3 = linkListItemProps.subText3,
    subText3Bold = linkListItemProps.subText3Bold,
    _linkListItemProps$su3 = linkListItemProps.subText3BoldControlState,
    subText3BoldControlState = _linkListItemProps$su3 === void 0 ? 'none' : _linkListItemProps$su3,
    showsSubText3InfoIcon = linkListItemProps.showsSubText3InfoIcon,
    subText3TooltipProps = linkListItemProps.subText3TooltipProps,
    subText3AccessibilityProps = linkListItemProps.subText3AccessibilityProps,
    subText3BoldAccessibilityProps = linkListItemProps.subText3BoldAccessibilityProps,
    subText3IconProps = linkListItemProps.subText3IconProps,
    subText3IconName = linkListItemProps.subText3IconName,
    imageUrl = linkListItemProps.imageUrl,
    imageProps = linkListItemProps.imageProps,
    ignoreDisabledStateForCardPress = linkListItemProps.ignoreDisabledStateForCardPress,
    disableAppendActionType = linkListItemProps.disableAppendActionType,
    restProps = __rest(linkListItemProps, ["theme", "title", "heading", "headingTextTransform", "subHeading", "subHeadingTextTransform", "subHeadingNumberOfLines", "subHeadingBold", "subHeadingBoldColor", "subHeadingBoldControlState", "showSubHeadingInfoIcon", "subHeadingTooltipProps", "subHeadingInfoIconPress", "multiTextSubText", "subText", "subTextBold", "multiTextHeading", "multiTextSubHeading", "subTextBoldControlState", "showsSubTextInfoIcon", "subTextTooltipProps", "subTextInfoIconPress", "metaInfoTag", "metaInfoTagIcon", "metaInfoTagType", "metaInfoText", "metaInfoCta", "metaInfoCtaAccessibilityProps", "metaInfoCtaProps", "avatarIcon", "avatarImgUrl", "avatarOnErrorImgUrl", "avatarNoBgContainer", "avatarAsOffer", "avatarProps", "showAvatarTooltip", "avatarTooltipProps", "actionType", "onPress", "style", "showDivider", "showInfoIcon", "infoIconAccessibilityProps", "showOnMountInfoIconTooltip", "infoIconTooltipProps", "headingInfoTag", "metaInfoCtaPress", "headingIconName", "subHeadingIconName", "subHeadingIconProps", "subHeadingPrefixIconName", "subHeadingPrefixIconProps", "subTextPrefixIconName", "subTextPrefixIconProps", "subText2PrefixIconName", "subText2PrefixIconProps", "subTextIconName", "subTextIconProps", "infoIconPress", "refreshCtaData", "onRefreshCtaTimerComplete", "onRefreshCtaPress", "headingIconColor", "headingInfoTagType", "actionTypeOnPress", "actionTypeProps", "selected", "testID", "accessible", "titleAccessibilityProps", "headingAccessibilityProps", "subHeadingAccessibilityProps", "subTextAccessibilityProps", "metaInfoTextAccessibilityProps", "showCtaLoader", "dynamicTooltipProps", "showDynamicTooltip", "showHeadingLottie", "headingLottieProps", "config", "isLoading", "subText3InfoIconPress", "subText3", "subText3Bold", "subText3BoldControlState", "showsSubText3InfoIcon", "subText3TooltipProps", "subText3AccessibilityProps", "subText3BoldAccessibilityProps", "subText3IconProps", "subText3IconName", "imageUrl", "imageProps", "ignoreDisabledStateForCardPress", "disableAppendActionType"]);
  var hasMetaInfoTagOrMetaInfoText = metaInfoTag || metaInfoText;
  var showAvatar = avatarIcon || avatarImgUrl;
  var tooltipId = dynamicTooltipProps.id;
  var showAvatarType = avatarIcon ? 'iconName' : 'imageUrl';
  var avatarProps = Object.assign({
    noBgContainer: avatarNoBgContainer,
    size: getLinkListItemComponentSize('avatarSize', isLargeScreen, actionType),
    variant: avatarIcon ? 'icon' : 'image',
    [showAvatarType]: avatarIcon || avatarImgUrl,
    onErrorImageUrl: avatarOnErrorImgUrl
  }, _avatarProps);
  var _useState2 = useState(showOnMountInfoIconTooltip),
    showInfoIconTooltip = _useState2[0],
    setShowInfoIconTooltip = _useState2[1];
  var _useState3 = useState(showAvatarTooltip),
    isAvatarTooltipVisible = _useState3[0],
    setIsAvatarTooltipVisible = _useState3[1];
  var _useState4 = useState(false),
    showTooltipSubHeading = _useState4[0],
    setShowTooltipSubHeading = _useState4[1];
  var _useState5 = useState(false),
    showTooltipSubText = _useState5[0],
    setShowTooltipSubText = _useState5[1];
  var _useState6 = useState(false),
    showTooltipSubText3 = _useState6[0],
    setShowTooltipSubText3 = _useState6[1];
  var _useState7 = useState(refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.ctaText),
    refreshCtaText = _useState7[0],
    setRefreshCtaText = _useState7[1];
  var _useState8 = useState(false),
    refreshCtaLoading = _useState8[0],
    setRefreshCtaLoading = _useState8[1];
  var TIMEOUT = refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.timer;
  var timer = useRef(null);
  useEffect(() => {
    if (!refreshCtaLoading) {
      setIsDisabled(disabled || _controlState === 'disabled');
    }
  }, [disabled, _controlState, refreshCtaLoading]);
  var getPressableStyle = useCallback(event => {
    var styles = getLinkListItemStyles(linkListItemProps, event, isLargeScreen);
    stylesBasedOnState.current = styles;
    return [styles.container, style];
  }, [JSON.stringify(linkListItemProps), isLargeScreen]);
  var iconComponent = null;
  if (actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName) {
    if (actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconAsAction) {
      iconComponent = _jsx(Pressable, Object.assign({
        onPress: actionTypeOnPress
      }, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconAccessibilityProps, {
        children: _jsx(DynamicSvg, Object.assign({
          iconName: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName,
          fontSize: getLinkListItemComponentSize('iconSize', isLargeScreen, actionType)
        }, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconAccessibilityProps, {
          color: (actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconColor) || BLUE_500
        }, getTestId(testID, 'icon')))
      }));
    } else {
      iconComponent = _jsx(DynamicSvg, Object.assign({
        iconName: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName,
        fontSize: getLinkListItemComponentSize('iconSize', isLargeScreen, actionType)
      }, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconAccessibilityProps, {
        color: (actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconColor) || BLACK_600
      }, getTestId(testID, 'icon')));
    }
  }
  var InfoTagComponent = _ref => {
    var style = _ref.style;
    return _jsx(InfoTag, Object.assign({
      theme: theme,
      size: getLinkListItemComponentSize('infoTagSize', isLargeScreen, actionType),
      type: "inline",
      subType: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.infoTagType,
      text: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.infoTagText,
      style: style,
      disabled: disableAppendActionType
    }, getTestId(testID, 'infoTag')));
  };
  var TextComponent = _ref2 => {
    var style = _ref2.style;
    return _jsx(Typography, Object.assign({
      text: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.text,
      color: getActionTypeTextStateColor(actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.textState),
      type: getLinkListItemComponentSize('textSize', isLargeScreen, actionType),
      style: style
    }, getTestId(testID, 'text')));
  };
  var GET_ACTION_COMPONENT = {
    none: _jsx(_Fragment, {}),
    icon: _jsx(_Fragment, {
      children: iconComponent
    }),
    button: _jsx(ButtonComponent, {
      theme: theme,
      isLargeScreen: isLargeScreen,
      actionType: actionType,
      isDisabled: disableAppendActionType || isDisabled,
      showCtaLoader: showCtaLoader,
      actionTypeOnPress: actionTypeOnPress,
      testID: testID,
      actionTypeProps: actionTypeProps
    }),
    'button-icon': _jsxs(View, Object.assign({
      style: stylesBasedOnState.current.flexRow
    }, {
      children: [_jsx(ButtonComponent, {
        theme: theme,
        style: stylesBasedOnState.current.rightSafeSpace,
        isLargeScreen: isLargeScreen,
        actionType: actionType,
        isDisabled: disableAppendActionType || isDisabled,
        showCtaLoader: showCtaLoader,
        actionTypeOnPress: actionTypeOnPress,
        testID: testID,
        actionTypeProps: actionTypeProps
      }), iconComponent]
    })),
    radio: _jsx(RadioComponent, {
      theme: theme,
      isLargeScreen: isLargeScreen,
      actionType: actionType,
      isDisabled: disableAppendActionType || isDisabled,
      selected: selected,
      actionTypeOnPress: actionTypeOnPress,
      testID: testID,
      actionTypeProps: actionTypeProps
    }),
    text: _jsx(TextComponent, {}),
    'text-icon': _jsxs(View, Object.assign({
      style: stylesBasedOnState.current.flexRow
    }, {
      children: [_jsx(TextComponent, {
        style: stylesBasedOnState.current.rightSafeSpace
      }), iconComponent]
    })),
    infoTag: _jsx(InfoTagComponent, {}),
    'infoTag-radio': _jsxs(View, Object.assign({
      style: stylesBasedOnState.current.flexRow
    }, {
      children: [_jsx(InfoTagComponent, {
        style: stylesBasedOnState.current.rightSafeSpace
      }), _jsx(RadioComponent, {
        theme: theme,
        isLargeScreen: isLargeScreen,
        actionType: actionType,
        isDisabled: isDisabled,
        selected: selected,
        actionTypeOnPress: actionTypeOnPress,
        testID: testID,
        actionTypeProps: actionTypeProps
      })]
    })),
    'infoTag-icon': _jsxs(View, Object.assign({
      style: stylesBasedOnState.current.flexRow
    }, {
      children: [_jsx(InfoTagComponent, {
        style: stylesBasedOnState.current.rightSafeSpace
      }), iconComponent]
    })),
    checkbox: _jsx(Checkbox, Object.assign({
      theme: theme,
      size: getLinkListItemComponentSize('checkboxSize', isLargeScreen, actionType),
      disabled: disableAppendActionType || isDisabled,
      checked: selected,
      onPress: e => {
        var data = Object.assign(Object.assign({}, e), {
          checked: selected
        });
        actionTypeOnPress === null || actionTypeOnPress === void 0 ? void 0 : actionTypeOnPress(data);
      }
    }, getTestId(testID, 'checkbox'), actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.accessibilityProps)),
    switch: _jsx(Switch, Object.assign({
      theme: theme,
      size: getLinkListItemComponentSize('switchSize', isLargeScreen, actionType),
      disabled: disableAppendActionType || isDisabled,
      checked: selected,
      onPress: e => {
        var data = {
          event: e,
          checked: selected
        };
        actionTypeOnPress === null || actionTypeOnPress === void 0 ? void 0 : actionTypeOnPress(data);
      }
    }, getTestId(testID, 'switch'), actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.accessibilityProps))
  };
  var refreshCtaTimerHandler = event => {
    onRefreshCtaPress === null || onRefreshCtaPress === void 0 ? void 0 : onRefreshCtaPress(event);
    var timerValue = refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.timer;
    setRefreshCtaLoading(true);
    setRefreshCtaText((refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.timerCtaText) + " " + timerValue + "S");
    setIsDisabled(true);
    timer.current = setInterval(() => {
      timerValue -= 1;
      setRefreshCtaText((refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.timerCtaText) + " " + timerValue + "S");
    }, 1000);
    setTimeout(() => {
      clearInterval(timer.current);
      setRefreshCtaText(refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.ctaText);
      onRefreshCtaTimerComplete();
      setRefreshCtaLoading(false);
      setIsDisabled(false);
    }, TIMEOUT * 1000);
  };
  var showLinkList = !!title || !!heading || !!subHeading || !!metaInfoCta || !!subHeadingBold || !!multiTextHeading || !!subText || !!subTextBold || !!subText3 || !!subText3Bold || !!multiTextSubHeading || !!multiTextSubText;
  var innerAccessibility = !accessible;
  var avatarIconColor = (_b = (_a = config === null || config === void 0 ? void 0 : config.controlStates) === null || _a === void 0 ? void 0 : _a[controlState]) === null || _b === void 0 ? void 0 : _b.avatarIconColor;
  var isPressableDisabled = ignoreDisabledStateForCardPress ? false : isDisabled;
  return _jsx(_Fragment, {
    children: !!showLinkList && _jsxs(_Fragment, {
      children: [_jsx(Pressable, Object.assign({
        ref: ref,
        style: getPressableStyle,
        onPress: _onPress,
        accessible: accessible
      }, checkIsPlatform('web') && {
        tabIndex: 1
      }, getTestId(testID), restProps, {
        disabled: isPressableDisabled
      }, {
        children: event => {
          var _a;
          return _jsxs(_Fragment, {
            children: [!!imageUrl && _jsx(Image, Object.assign({
              source: {
                uri: imageUrl
              },
              resizeMode: "contain",
              style: stylesBasedOnState.current.image
            }, imageProps, getTestId(testID, 'imageUrl'))), !!showAvatar && _jsx(View, Object.assign({
              style: [stylesBasedOnState.current.avatarContainer, props === null || props === void 0 ? void 0 : props.avatarWrapperStyle]
            }, {
              children: _jsx(Tooltip, Object.assign({
                theme: theme,
                position: "bottom-start",
                offset: {
                  bottom: 10
                }
              }, avatarTooltipProps, {
                isVisible: showAvatarTooltip && isAvatarTooltipVisible,
                onClose: data => {
                  var _a;
                  (_a = avatarTooltipProps === null || avatarTooltipProps === void 0 ? void 0 : avatarTooltipProps.onClose) === null || _a === void 0 ? void 0 : _a.call(avatarTooltipProps, data);
                  if (avatarTooltipProps === null || avatarTooltipProps === void 0 ? void 0 : avatarTooltipProps.autoHide) {
                    setIsAvatarTooltipVisible(false);
                  }
                }
              }, getTestId(testID, 'avatarTooltip'), {
                children: _jsx(Pressable, Object.assign({
                  onPress: () => {
                    if (showAvatarTooltip) {
                      setIsAvatarTooltipVisible(prev => !prev);
                    }
                    avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.onPress({
                      isTooltipVisible: isAvatarTooltipVisible
                    });
                  }
                }, {
                  children: _jsx(AvatarWrapper, Object.assign({
                    avatarAsOffer: avatarAsOffer,
                    avatarAsOfferStyle: stylesBasedOnState.current.avatarAsOffer
                  }, {
                    children: _jsx(Avatar, Object.assign({
                      theme: theme,
                      disabled: isDisabled
                    }, avatarProps, {
                      iconProps: Object.assign(Object.assign(Object.assign({}, avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.iconProps), {
                        color: ((_a = avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.iconProps) === null || _a === void 0 ? void 0 : _a.color) || avatarIconColor
                      }), avatarAsOffer && {
                        color: WHITE
                      }),
                      style: [stylesBasedOnState.current.avatar, avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.style]
                    }, avatarNoBgContainer && {
                      outerContainerStyles: [stylesBasedOnState.current.avatarOuterContainerStyles, avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.outerContainerStyles]
                    }, getTestId(testID, 'avatar')))
                  }))
                }))
              }))
            })), _jsxs(View, Object.assign({
              style: stylesBasedOnState.current.typographySpacing
            }, {
              children: [!!title && _jsx(Typography, Object.assign({
                accessible: innerAccessibility
              }, titleAccessibilityProps, {
                text: title,
                style: stylesBasedOnState.current.title,
                type: getTypography('title', isLargeScreen),
                color: getTypographyColorWithDifferentStates(linkListItemProps, 'titleColor', event)
              }, getTestId(testID, 'title'))), _jsxs(View, Object.assign({
                style: stylesBasedOnState.current.headingContainer
              }, {
                children: [(!!heading || !!multiTextHeading) && _jsx(Typography, Object.assign({
                  accessible: innerAccessibility
                }, headingAccessibilityProps, {
                  text: heading,
                  multiText: multiTextHeading,
                  numberOfLines: 2,
                  type: getTypography('heading', isLargeScreen),
                  style: [stylesBasedOnState.current.heading, {
                    textTransform: headingTextTransform
                  }],
                  color: getTypographyColorWithDifferentStates(linkListItemProps, 'headingColor', event)
                }, getTestId(testID, 'heading'))), showHeadingLottie && _jsx(Lottie, Object.assign({}, headingLottieProps, {
                  style: [stylesBasedOnState.current.headingLottie, headingLottieProps === null || headingLottieProps === void 0 ? void 0 : headingLottieProps.style]
                })), showInfoIcon && _jsx(Tooltip, Object.assign({
                  theme: theme,
                  position: isLargeScreen ? 'bottom-start' : 'bottom-center',
                  offset: {
                    x: -10,
                    y: -6
                  }
                }, infoIconTooltipProps, {
                  isVisible: showInfoIconTooltip,
                  onClose: () => {
                    if (infoIconTooltipProps === null || infoIconTooltipProps === void 0 ? void 0 : infoIconTooltipProps.autoHide) {
                      setShowInfoIconTooltip(false);
                    }
                  }
                }, getTestId(testID, 'showInfoIcon'), {
                  children: _jsx(Pressable, Object.assign({
                    accessible: true,
                    onPress: () => {
                      setShowInfoIconTooltip(!showInfoIconTooltip);
                      infoIconPress();
                    }
                  }, {
                    children: _jsx(InfoIcon, Object.assign({
                      color: BLUE_500,
                      fontSize: 16,
                      style: stylesBasedOnState.current.icon
                    }, infoIconAccessibilityProps, getTestId(testID, 'infoIcon')))
                  }))
                })), !!headingInfoTag && _jsx(InfoTag, Object.assign({
                  theme: theme,
                  size: isLargeScreen ? 'md' : 'sm',
                  type: "inline",
                  subType: headingInfoTagType,
                  text: headingInfoTag,
                  style: stylesBasedOnState.current.headingInfoTag
                }, getTestId(testID, 'headingInfoTag'))), _jsx(DynamicSvg, Object.assign({
                  iconName: headingIconName,
                  fontSize: 16,
                  color: headingIconColor,
                  style: stylesBasedOnState.current.icon
                }, getTestId(testID, 'headingIcon')))]
              })), (!!subHeading || !!subHeadingBold || !!multiTextSubHeading) && _jsxs(View, Object.assign({
                accessibilityLabel: "" + (subHeading || '') + (subHeadingBold ? " " + subHeadingBold : ''),
                style: stylesBasedOnState.current.subHeadingContainer
              }, {
                children: [!!subHeadingPrefixIconName && _jsx(DynamicSvg, Object.assign({
                  iconName: subHeadingPrefixIconName,
                  fontSize: isLargeScreen ? 20 : 16,
                  color: BLACK
                }, subHeadingPrefixIconProps, {
                  style: stylesBasedOnState.current.subtextPrefixicon
                }, getTestId(testID, 'subHeadingPrefixIcon'))), _jsx(Typography, Object.assign({}, getTestId(testID, 'subHeading'), {
                  multiText: multiTextSubHeading || [Object.assign(Object.assign({}, getTestId(testID, 'subHeading')), {
                    text: subHeading,
                    type: getTypography('subHeading', isLargeScreen),
                    color: getTypographyColorWithDifferentStates(linkListItemProps, 'subHeadingColor', event),
                    style: [stylesBasedOnState.current.tooltipHandling, {
                      textTransform: subHeadingTextTransform
                    }]
                  }), Object.assign(Object.assign({}, getTestId(testID, 'subHeadingBold')), {
                    text: subHeadingBold,
                    isBold: true,
                    style: stylesBasedOnState.current.subHeadingBoldText,
                    type: getTypography('subHeadingBold', isLargeScreen),
                    color: subHeadingBoldColor || subHeadingBoldControlState && getSubHeadingBoldTypeColor(subHeadingBoldControlState, disabled, controlState)
                  })]
                }, subHeadingAccessibilityProps, !!subHeadingNumberOfLines && {
                  numberOfLines: subHeadingNumberOfLines
                })), showSubHeadingInfoIcon && _jsx(Tooltip, Object.assign({
                  theme: theme,
                  position: isLargeScreen ? 'bottom-start' : 'bottom-center',
                  offset: {
                    x: -10,
                    y: -6
                  }
                }, subHeadingTooltipProps, {
                  isVisible: showTooltipSubHeading,
                  onClose: () => {
                    if (subHeadingTooltipProps === null || subHeadingTooltipProps === void 0 ? void 0 : subHeadingTooltipProps.autoHide) {
                      setShowTooltipSubHeading(false);
                    }
                  }
                }, getTestId(testID, 'subHeadingIcon'), {
                  children: _jsx(Pressable, Object.assign({
                    accessible: true,
                    onPress: () => {
                      setShowTooltipSubHeading(!showTooltipSubHeading);
                      subHeadingInfoIconPress();
                    }
                  }, {
                    children: _jsx(InfoIcon, Object.assign({
                      color: BLUE_500,
                      fontSize: isLargeScreen ? 20 : 16,
                      style: stylesBasedOnState.current.icon
                    }, getTestId(testID, 'showSubHeadingInfoIcon')))
                  }))
                })), !!subHeadingIconName && _jsx(DynamicSvg, Object.assign({
                  iconName: subHeadingIconName,
                  fontSize: 16,
                  color: BLACK
                }, subHeadingIconProps, {
                  style: stylesBasedOnState.current.icon
                }, getTestId(testID, 'subheadingIcon')))]
              })), (!!subText || !!subTextBold || (multiTextSubText === null || multiTextSubText === void 0 ? void 0 : multiTextSubText.length) > 0) && _jsxs(View, Object.assign({
                style: stylesBasedOnState.current.subTextContainer
              }, {
                children: [showsSubTextInfoIcon && _jsx(Tooltip, Object.assign({
                  theme: theme,
                  position: isLargeScreen ? 'bottom-start' : 'bottom-center',
                  offset: {
                    x: -10,
                    y: -6
                  }
                }, subTextTooltipProps, {
                  isVisible: showTooltipSubText,
                  onClose: () => {
                    if (subTextTooltipProps === null || subTextTooltipProps === void 0 ? void 0 : subTextTooltipProps.autoHide) {
                      setShowTooltipSubText(false);
                    }
                  }
                }, getTestId(testID, 'subTextIcon'), {
                  children: _jsx(Pressable, Object.assign({
                    onPress: () => {
                      setShowTooltipSubText(!showTooltipSubText);
                      subTextInfoIconPress();
                    },
                    style: stylesBasedOnState.current.subTextIcon
                  }, {
                    children: _jsx(InfoIcon, Object.assign({
                      color: BLUE_500,
                      fontSize: isLargeScreen ? 20 : 16
                    }, getTestId(testID, 'infoIcon')))
                  }))
                })), !!subTextPrefixIconName && _jsx(DynamicSvg, Object.assign({
                  iconName: subTextPrefixIconName,
                  fontSize: isLargeScreen ? 20 : 16,
                  color: BLACK
                }, subTextPrefixIconProps, {
                  style: stylesBasedOnState.current.subtextPrefixicon
                }, getTestId(testID, 'subTextPrefixIcon'))), _jsx(Typography, Object.assign({
                  multiText: (multiTextSubText === null || multiTextSubText === void 0 ? void 0 : multiTextSubText.length) > 0 ? multiTextSubText : [Object.assign(Object.assign({
                    text: subText,
                    type: getTypography('subHeading', isLargeScreen),
                    color: getTypographyColorWithDifferentStates(linkListItemProps, 'subHeadingColor', event)
                  }, getTestId(testID, 'subText')), {
                    style: stylesBasedOnState.current.subText
                  }), Object.assign({
                    text: subTextBold,
                    type: getTypography('subHeadingBold', isLargeScreen),
                    color: subTextBoldControlState && getSubHeadingBoldTypeColor(subTextBoldControlState, disabled, controlState)
                  }, getTestId(testID, 'subTextBold'))]
                }, subTextAccessibilityProps)), _jsx(DynamicSvg, Object.assign({
                  iconName: subTextIconName,
                  fontSize: 16,
                  color: BLACK
                }, subTextIconProps, {
                  style: stylesBasedOnState.current.icon
                }, getTestId(testID, 'SubTextIcon')))]
              })), (!!subText3 || !!subText3Bold) && _jsxs(View, Object.assign({
                style: stylesBasedOnState.current.subText3Container
              }, {
                children: [!!subText2PrefixIconName && _jsx(DynamicSvg, Object.assign({
                  iconName: subText2PrefixIconName,
                  fontSize: isLargeScreen ? 20 : 16,
                  color: BLACK
                }, subText2PrefixIconProps, {
                  style: stylesBasedOnState.current.subtextPrefixicon
                }, getTestId(testID, 'subText2PrefixIcon'))), _jsx(Typography, Object.assign({
                  text: subText3,
                  accessible: innerAccessibility
                }, subText3AccessibilityProps, {
                  type: getTypography('subText3', isLargeScreen),
                  color: getTypographyColorWithDifferentStates(linkListItemProps, 'subHeadingColor', event)
                }, getTestId(testID, 'subText3'), {
                  style: stylesBasedOnState.current.subText
                })), showsSubText3InfoIcon && _jsx(Tooltip, Object.assign({
                  theme: theme,
                  position: isLargeScreen ? 'bottom-start' : 'bottom-center',
                  offset: {
                    x: -10,
                    y: -6
                  }
                }, subText3TooltipProps, {
                  isVisible: showTooltipSubText3,
                  onClose: () => {
                    if (subText3TooltipProps === null || subText3TooltipProps === void 0 ? void 0 : subText3TooltipProps.autoHide) {
                      setShowTooltipSubText3(false);
                    }
                  }
                }, getTestId(testID, 'subTextIcon'), {
                  children: _jsx(Pressable, Object.assign({
                    onPress: () => {
                      setShowTooltipSubText3(!showTooltipSubText3);
                      subText3InfoIconPress();
                    },
                    style: stylesBasedOnState.current.subTextIcon
                  }, {
                    children: _jsx(InfoIcon, Object.assign({
                      color: BLUE_500,
                      fontSize: isLargeScreen ? 20 : 16
                    }, getTestId(testID, 'subText3infoIcon')))
                  }))
                })), _jsx(Typography, Object.assign({
                  accessible: innerAccessibility
                }, subText3BoldAccessibilityProps, {
                  text: subText3Bold,
                  type: getTypography('subText3Bold', isLargeScreen),
                  color: subHeadingBoldColor || subText3BoldControlState && getSubHeadingBoldTypeColor(subText3BoldControlState, disabled, controlState)
                }, getTestId(testID, 'subText3Bold'))), _jsx(DynamicSvg, Object.assign({
                  iconName: subText3IconName,
                  fontSize: isLargeScreen ? 20 : 16,
                  color: BLACK
                }, subText3IconProps, {
                  style: stylesBasedOnState.current.icon
                }, getTestId(testID, 'SubTextIcon')))]
              })), !!hasMetaInfoTagOrMetaInfoText && _jsxs(View, Object.assign({
                style: [stylesBasedOnState.current.infoTextContainer, stylesBasedOnState.current.tooltipHandling]
              }, {
                children: [!!metaInfoTag && _jsx(InfoTag, Object.assign({
                  theme: theme,
                  size: isLargeScreen ? 'md' : 'sm',
                  type: "inline",
                  iconName: metaInfoTagIcon,
                  subType: metaInfoTagType,
                  text: metaInfoTag,
                  style: stylesBasedOnState.current.metaInfoTag
                }, getTestId(testID, 'metaInfoTag'))), !!metaInfoText && _jsx(Typography, Object.assign({
                  accessible: innerAccessibility
                }, metaInfoTextAccessibilityProps, {
                  text: metaInfoText,
                  type: getTypography('metaInfoText', isLargeScreen),
                  color: getTypographyColorWithDifferentStates(linkListItemProps, 'infoTextColor', event)
                }, getTestId(testID, 'metaInfoText')))]
              })), !!metaInfoCta && _jsx(Tooltip, Object.assign({
                id: "metaInfoCta",
                isVisible: showDynamicTooltip && tooltipId === 'metaInfoCta',
                position: "bottom-start"
              }, dynamicTooltipProps, {
                children: _jsx(Button, Object.assign({
                  theme: theme
                }, metaInfoCtaProps, {
                  showLoader: showCtaLoader,
                  size: isLargeScreen ? 'md' : 'sm',
                  disabled: isDisabled,
                  title: metaInfoCta,
                  version: "fixed-padding",
                  buttonType: "tertiary",
                  onPress: metaInfoCtaPress,
                  style: [stylesBasedOnState.current.metaInfoCta, stylesBasedOnState.current.tooltipHandling, metaInfoCtaProps === null || metaInfoCtaProps === void 0 ? void 0 : metaInfoCtaProps.style]
                }, metaInfoCtaAccessibilityProps, getTestId(testID, 'metaInfoCta')))
              })), TIMEOUT > 0 && _jsx(Tooltip, Object.assign({
                theme: theme,
                id: "refreshCta",
                isVisible: showDynamicTooltip && tooltipId == 'refreshCta'
              }, dynamicTooltipProps, {
                children: _jsx(Button, Object.assign({
                  theme: theme,
                  loaderPosition: "left",
                  showLoader: refreshCtaLoading,
                  size: isLargeScreen ? 'md' : 'sm',
                  disabled: isDisabled,
                  iconPosition: "left",
                  iconName: !refreshCtaLoading && (refreshCtaData === null || refreshCtaData === void 0 ? void 0 : refreshCtaData.iconName),
                  title: refreshCtaText,
                  version: "fixed-padding",
                  buttonType: "tertiary",
                  onPress: refreshCtaTimerHandler,
                  style: stylesBasedOnState.current.metaInfoCta
                }, getTestId(testID, 'refreshCta')))
              }))]
            })), actionType !== 'none' && _jsx(View, Object.assign({
              accessible: innerAccessibility
            }, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.accessibilityProps, {
              style: [stylesBasedOnState.current.rightContainer, stylesBasedOnState.current.tooltipHandling]
            }, {
              children: _jsx(Tooltip, Object.assign({
                theme: theme,
                id: "actionType",
                isVisible: showDynamicTooltip && tooltipId == 'actionType',
                position: "bottom-start"
              }, dynamicTooltipProps, {
                children: isLoading ? _jsx(Loader, {
                  noPadding: true,
                  size: isLargeScreen ? 'md' : 'sm'
                }) : GET_ACTION_COMPONENT[actionType]
              }))
            }))]
          });
        }
      })), showDivider && _jsx(Divider, {})]
    })
  });
});
var AvatarWrapper = _ref3 => {
  var avatarAsOffer = _ref3.avatarAsOffer,
    avatarAsOfferStyle = _ref3.avatarAsOfferStyle,
    children = _ref3.children;
  return _jsx(_Fragment, {
    children: avatarAsOffer ? _jsx(GradientView, Object.assign({
      style: avatarAsOfferStyle,
      type: "RETRO"
    }, {
      children: children
    })) : children
  });
};
var ButtonComponent = _ref4 => {
  var theme = _ref4.theme,
    style = _ref4.style,
    showCtaLoader = _ref4.showCtaLoader,
    actionType = _ref4.actionType,
    isDisabled = _ref4.isDisabled,
    isLargeScreen = _ref4.isLargeScreen,
    actionTypeOnPress = _ref4.actionTypeOnPress,
    testID = _ref4.testID,
    actionTypeProps = _ref4.actionTypeProps,
    disableAppendActionType = _ref4.disableAppendActionType;
  return _jsx(Button, Object.assign({}, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.buttonProps, {
    theme: theme,
    showLoader: showCtaLoader,
    onPress: e => actionTypeOnPress === null || actionTypeOnPress === void 0 ? void 0 : actionTypeOnPress({
      event: e
    }),
    title: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.buttonText,
    version: "fixed-padding",
    buttonType: "tertiary",
    size: getLinkListItemComponentSize('buttonSize', isLargeScreen, actionType),
    disabled: disableAppendActionType || isDisabled,
    style: style
  }, getTestId(testID, 'button')));
};
var RadioComponent = _ref5 => {
  var theme = _ref5.theme,
    isLargeScreen = _ref5.isLargeScreen,
    actionType = _ref5.actionType,
    isDisabled = _ref5.isDisabled,
    selected = _ref5.selected,
    actionTypeOnPress = _ref5.actionTypeOnPress,
    testID = _ref5.testID,
    actionTypeProps = _ref5.actionTypeProps,
    disableAppendActionType = _ref5.disableAppendActionType;
  return _jsx(Radio, Object.assign({
    theme: theme,
    size: getLinkListItemComponentSize('radioSize', isLargeScreen, actionType),
    disabled: disableAppendActionType || isDisabled,
    checked: selected,
    onPress: e => {
      var data = Object.assign(Object.assign({}, e), {
        checked: selected
      });
      actionTypeOnPress === null || actionTypeOnPress === void 0 ? void 0 : actionTypeOnPress(data);
    }
  }, getTestId(testID, 'radio'), actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.accessibilityProps));
};